import { useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteReport = () => {
  const queryClient = useQueryClient();

  return apiClient.reports.deleteReport.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Error deleting the report!');
    },
  });
};
